var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"letter"},[_c('board-list-component',{attrs:{"boardType":'letter'}})],1),_vm._m(0)]),_c('transition',{attrs:{"name":`detail-${_vm.$root.$children[0].transitionName}`}},[_c('router-view')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"to_top"})])
}]

export { render, staticRenderFns }